/* eslint-disable  @typescript-eslint/no-explicit-any */
export type Tagged<S extends symbol, T> = { tag: S } & T;
export const LOADING = Symbol('LOADING');
export const LOADED = Symbol('LOADED');
export type Loading = Tagged<typeof LOADING, Record<string, unknown>>;
export const loading: Loading = { tag: LOADING };
export const isLoading = (state: any): state is Loading => {
  return state.tag && state.tag === LOADING;
};
export type Loaded<T extends string, S> = Tagged<typeof LOADED, Record<T, S>>;
export const loaded = <T extends string, S>(
  state: Record<T, S>
): Loaded<T, S> => ({
  ...state,
  tag: LOADED,
});
export const isLoaded = <T extends string, S>(
  state: any
): state is Loaded<T, S> => {
  return state.tag && state.tag === LOADED;
};
export type State<T extends string, S> = Loading | Loaded<T, S>;
export type GetAPI<T> = () => Promise<T>;

export const fmap = <TA extends string, SA, TB extends string, SB>(
  f: (value: Record<TA, SA>) => Record<TB, SB>
) => (state: State<TA, SA>): State<TB, SB> => {
  if (isLoading(state)) return loading;
  return loaded(f(state));
};
